var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_45456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6304 0H25.7153C31.7827 0 36.7016 5.00389 36.7016 11.1765V26.8236C36.7016 32.996 31.7827 38 25.7153 38H24.6167C18.5492 38 13.6304 32.996 13.6304 26.8236V0Z",
    fill: "url(#paint0_linear_400_45456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1765C0 5.00389 4.9187 0 10.9862 0H23.0711V26.8236C23.0711 32.996 18.1524 38 12.0848 38H10.9862C4.9187 38 0 32.996 0 26.8236V11.1765Z",
    fill: "url(#paint1_linear_400_45456)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_45456",
    x1: 19.0137,
    y1: -1.34117,
    x2: 36.0305,
    y2: 62.4449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#15395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112A45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_400_45456",
    x1: -5.49311,
    y1: -9.38823,
    x2: 17.0421,
    y2: 51.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65B7F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_400_45456",
    x1: 75.7711,
    y1: 10.1333,
    x2: 75.7711,
    y2: 32.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#177DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164C7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_400_45456",
    x1: 75.7711,
    y1: 10.1333,
    x2: 75.7711,
    y2: 32.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#177DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164C7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_400_45456",
    x1: 75.7711,
    y1: 10.1333,
    x2: 75.7711,
    y2: 32.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#177DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164C7E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_45456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoText);
export default __webpack_public_path__ + "static/media/logoNoText.eabb52eb6210ef2b631add35048c42f1.svg";
export { ForwardRef as ReactComponent };